import React, { createContext, useContext } from "react";

const BlurContext = createContext();

export const BlurProvider = ({ children }) => {
  return (
    <BlurContext.Provider value={{ isBlurred: false, userChecked: true }}>
      {children}
    </BlurContext.Provider>
  );
};

export const useBlur = () => useContext(BlurContext);
